<template>
  <div class="multiple-question quiz-answers">
    <div
      v-for="(answer, index) in question.answers"
      class="quiz-answer"
      :key="answer.text"
      :disabled="resolve"
    >
      <label :class="{'radio':maxChoice}">
        <input
          type="checkbox"
          v-model="answers"
          :value="index"
          @input="toggleCheck(index,$event.target.checked)"
        >
        <span class="checkround" v-if="maxChoice"></span>
        <span class="ml-2 mr-1 question-num"
              :class="getButtonClass(index)">
          {{indexToLetter(index)}}.
        </span>
        {{ answer.content }}
      </label>


      <blockquote class="quiz-explanation" v-if="resolve">
        <i class="icon icon-message"></i> {{ answer.explanation }}
      </blockquote>
    </div>

    <div class="nav-question text-right" v-show="!resolve">
      <button class="btn btn-primary" @click="answer">{{ $t('next') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultipleQuestion',
  props: ['question', 'resolve', 'sendAnswer', 'maxChoice', 'prevAnswer'],
  data() {
    return {
      answers: this.question.answer ? this.question.answer : [],
    };
  },
  watch: {
    question() {
      this.answers = this.question.answer ? this.question.answer : [];
    },
  },
  methods: {
    answer() {
      if (this.answers.length > 0) {
        const answers = this.answers.sort();
        this.sendAnswer(answers);
        this.answers = [];
      } else {
        this.sendAnswer(this.answers);
      }
    },
    toggleCheck(idx, check) {
      if (this.maxChoice === 1) {
        this.answers = [];
        if (check) {
          this.answers.push(idx);
        }
      }
    },

    getButtonClass(index) {
      const cl = [];
      if (this.resolve) {
        cl.push(this.question.resolution.includes(index) ? 'option-correct' : 'option-wrong');
      }
      return cl.join(' ');
    },
  },
};
</script>

<style scoped>
  .radio {

    display: block;
    position: relative;
    padding-left: 18px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none
  }

  /* Hide the browser's default radio button */
  .radio input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* Create a custom radio button */
  .checkround {
    position: absolute;
    top: 6px;
    left: 0;
    height: 14px;
    width: 14px;
    background-color: #fff;
    border-color: #767676;
    border-style: solid;
    border-width: 1px;
    border-radius: 50%;
  }


  /* When the radio button is checked, add a blue background */
  .radio input:checked ~ .checkround {
    background-color: #fff;
    border-color:#0075FF ;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkround:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .radio input:checked ~ .checkround:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .radio .checkround:after {
    left: 2px;
    top: 2px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #0075FF;
  }
</style>
